exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trip-apartment-form .dropdown-toggle {\n  color: #535862;\n  border: 1px solid #D5D7DA;\n  border-radius: 8px 8px 0 0 !important;\n  min-width: 160px;\n}\n@media screen and (min-width: 768px) {\n  .trip-apartment-form .dropdown-toggle {\n    border-radius: 8px 0 0 8px !important;\n    border-right: 0 none;\n    padding: 8px;\n  }\n}", ""]);

// exports
